import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NgrxStoreKeys } from '@warema/warema-plus/models';
import * as fromActivity from './activity/state/activity.reducers';
import { AppointmentMetadataService } from './appointment-metadata/services/appointment-metadata.service';
import * as fromAppointmentMetadata from './appointment-metadata/state/appointment-metadata.reducer';
import { ProductCategoryEffects } from './product-category/state/product-category.effects';
import * as fromProductCategory from './product-category/state/product-category.reducers';
import { SearchEffects } from './search/state/search.effects';
import * as fromSearch from './search/state/search.reducers';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(NgrxStoreKeys.ACTIVITY_FEATURE_KEY, fromActivity.reducer),
        StoreModule.forFeature(NgrxStoreKeys.SEARCH_FEATURE_KEY, fromSearch.reducer),
        StoreModule.forFeature(NgrxStoreKeys.APPOINTMENT_METADATA_FEATURE_KEY, fromAppointmentMetadata.reducer),
        EffectsModule.forFeature([ProductCategoryEffects, SearchEffects]),
        StoreModule.forFeature(NgrxStoreKeys.PRODUCT_CATEGORY_FEATURE_KEY, fromProductCategory.reducer),
    ],
    providers: [AppointmentMetadataService],
})
export class WaremaPlusCompanySearchDataAccessModule {}
